import React, { useState } from "react"
import { ButtonProps } from "../types/button"
import { FormattedMessage } from "react-intl"
import { ConfirmationModal } from "../modal"
import ActionButton from "./actionbutton.component"
import Icon from "../icon/icon.component"

export const DeleteButtonWithConfirmation = (props: ButtonProps) => {
    const [modal, setModal] = useState<React.ReactNode>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const onConfirm = () => {
        props.onClickCallback()
        setModal(null)
    }

    const onCancel = () => {
        setModal(null)
        setLoading(false)
    }

    const onModalOpen = () => {
        setLoading(true)
        setModal(
            <ConfirmationModal onConfirm={onConfirm} onCancel={onCancel}>
                <FormattedMessage
                    id="common.button.delete_button_with_confirmation.modal_text"
                    defaultMessage="Are you sure you want to delete?"
                />
            </ConfirmationModal>
        )
    }

    return (
        <>
            {modal}
            <ActionButton
                size={"sm"}
                className={props.className ?? "mr-2 btn-outline-danger btn-sm btn"}
                onClick={onModalOpen}
                isLoading={loading}
            >
                <Icon value={"trash"} className={"mr-1"}/>
                <FormattedMessage
                    id="common.placeholder.delete"
                    defaultMessage="Delete"/>
            </ActionButton>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/DeleteButtonWithConfirmation.tsx